import React from 'react';
import banner1 from "../../assets/banner1.jpg";
import banner2 from "../../assets/banner2.jpg";
import banner3 from "../../assets/banner3.jpg";
import banner4 from "../../assets/banner4.jpg";
import banner5 from "../../assets/banner5.jpg";
import banner6 from "../../assets/banner6.jpg";
import banner7 from "../../assets/banner7.jpg";

const ExperienceLayout = ({ hero, overview, highlights, details, itinerary }) => {
  const Icon = ({ children, color = '#28a745' }) => <span style={{ fontSize: '2.5rem', color }}>{children}</span>;

  return (
    <div style={{ maxWidth: '1400px', margin: '0 auto', fontFamily: 'system-ui, sans-serif' }}>
      {/* Hero */}
      <section
        style={{
          height: '70vh',
          backgroundImage: `linear-gradient(180deg, rgba(3, 8, 16, 0.78), rgba(3, 8, 16, 0.85)), url(${hero.backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          textAlign: 'center',
          padding: '0 2rem'
        }}
      >
        <div>
          <p style={{ fontSize: '1.2rem', marginBottom: '1rem', opacity: 0.9 }}>{hero.kicker}</p>
          <h1 style={{ fontSize: '3.5rem', marginBottom: '1rem', lineHeight: 1.1 }}>{hero.title}</h1>
          <p style={{ fontSize: '1.5rem', marginBottom: '2rem' }}>{hero.subtitle}</p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            {hero.meta.map((m, i) => <span key={i} style={{ background: 'rgba(255,255,255,0.2)', padding: '0.5rem 1rem', borderRadius: '20px' }}>{m}</span>)}
          </div>
        </div>
      </section>

      <div style={{ padding: '4rem 2rem' }}>
        {/* Overview */}
        <section style={{ marginBottom: '4rem', textAlign: 'center' }}>
          <h2 style={{ fontSize: '2.5rem', marginBottom: '1.5rem', color: '#333' }}>Overview</h2>
          <p style={{ fontSize: '1.1rem', lineHeight: 1.7, maxWidth: '800px', margin: '0 auto' }}>{overview}</p>
        </section>

        {/* Highlights */}
        <section style={{ marginBottom: '4rem' }}>
          <h2 style={{ fontSize: '2.5rem', marginBottom: '2rem', color: '#333' }}>Highlights</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
            {highlights.map((h, i) => {
              const HIcon = h.icon;
              return (
                <article key={i} style={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-start', padding: '1.5rem', background: '#f8f9fa', borderRadius: '8px' }}>
                  <div style={{ flexShrink: 0 }}>
                    <HIcon style={{ fontSize: '3rem', color: '#28a745' }} />
                  </div>
                  <div>
                    <h3 style={{ fontSize: '1.8rem', marginBottom: '0.5rem' }}>{h.title}</h3>
                    <p>{h.description}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </section>

        {/* Details */}
        <section style={{ marginBottom: '4rem' }}>
          <h2 style={{ fontSize: '2.5rem', marginBottom: '2rem', color: '#333' }}>Details</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
            {details.map((d, i) => {
              const DIcon = d.icon;
              return (
                <article key={i} style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                  <DIcon style={{ fontSize: '2rem', color: '#28a745', marginTop: '0.2rem' }} />
                  <div>
                    <h3 style={{ marginBottom: '0.5rem' }}>{d.title}</h3>
                    <p>{d.description}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </section>

        {/* Itinerary */}
        <section>
          <h2 style={{ fontSize: '2.5rem', marginBottom: '2rem', color: '#333' }}>Sample Itinerary</h2>
          <div className="row g-4">
            {itinerary.map((day, i) => (
              <div key={i} className="col-lg-4 col-md-6">
                <article className="h-100 card border-0 shadow-sm overflow-hidden rounded-3">
                  <div
                    className="card-img-top"
                    style={{
                      height: '200px',
                      backgroundImage: `url(${day.image})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }}
                  />
                  <div className="card-body p-4">
                    <p className="fw-bold text-success mb-2">{day.dayLabel}</p>
                    <h3 className="h5 mb-3">{day.title}</h3>
                    <p className="mb-3 line-height-6">{day.body}</p>
                    <p className="fw-bold text-muted small mb-0">Activities: {day.activities}</p>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default ExperienceLayout;

